const updateData = [
  {
    time: '10分钟前',
    title: '某女星深夜发文疑似回应离婚传闻',
    tag: '最新',
    tagColor: 'bg-primary-500',
  },
  {
    time: '25分钟前',
    title: '热门综艺录制现场突发状况，导演组紧急叫停',
    tag: '突发',
    tagColor: 'bg-primary-500',
  },
  {
    time: '1小时前',
    title: '知名导演新片杀青，主演阵容首度公开',
    tag: '独家',
    tagColor: 'bg-accent-500',
  },
  {
    time: '2小时前',
    title: '某品牌代言人风波后续：品牌方正式发布解约声明',
    tag: '跟进',
    tagColor: 'bg-secondary-500',
  },
  {
    time: '3小时前',
    title: '年度音乐颁奖礼提名名单公布，多位新人入围引关注',
    tag: '热点',
    tagColor: 'bg-primary-500',
  },
  {
    time: '4小时前',
    title: '网红直播带货翻车事件持续发酵，涉事品牌集体回应',
    tag: '热议',
    tagColor: 'bg-accent-500',
  },
  {
    time: '5小时前',
    title: '某实力派演员确认加盟好莱坞大片，国内粉丝沸腾',
    tag: '喜讯',
    tagColor: 'bg-accent-500',
  },
  {
    time: '6小时前',
    title: '娱乐圈"清朗行动"再出新规，多家平台积极响应',
    tag: '政策',
    tagColor: 'bg-secondary-500',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-primary-100">
            <i className="ri-flashlight-line text-primary-500 text-lg"></i>
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">最新快讯</h2>
        </div>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10 pl-11 md:pl-12">实时追踪娱乐圈最新动态，不错过任何一条爆料</p>

        <div className="relative">
          <div className="absolute left-4 md:left-5 top-0 bottom-0 w-0.5 bg-background-200"></div>
          <div className="space-y-5 md:space-y-6">
            {updateData.map((item, i) => (
              <div key={i} className="relative flex items-start gap-4 md:gap-5 pl-10 md:pl-12">
                <span className="absolute left-2.5 md:left-3.5 top-1.5 w-3 h-3 rounded-full border-2 border-primary-500 bg-background-50"></span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-xs text-foreground-400">{item.time}</span>
                    <span className={`px-2 py-0.5 rounded text-[10px] font-bold text-white ${item.tagColor}`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 font-medium leading-relaxed hover:text-primary-600 transition-colors cursor-pointer">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}